import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <img 
              src="https://static.readdy.ai/image/c10e9e76a30b13d22dd14b5eb889b083/0b5e06925b727ea3647571943e3d63a6.png" 
              alt="MediVoyage" 
              className="h-16 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm text-teal-50 leading-relaxed">
              {t('footer_about_text')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base font-semibold mb-4">{t('footer_quick_links')}</h3>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-sm text-teal-50 hover:text-white transition-colors">
                  {t('nav_home')}
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-teal-50 hover:text-white transition-colors">
                  {t('nav_services')}
                </a>
              </li>
              <li>
                <a href="#hospitals" className="text-sm text-teal-50 hover:text-white transition-colors">
                  {t('nav_hospitals')}
                </a>
              </li>
              <li>
                <a href="#about" className="text-sm text-teal-50 hover:text-white transition-colors">
                  {t('nav_about')}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-teal-50 hover:text-white transition-colors">
                  {t('nav_contact')}
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-base font-semibold mb-4">{t('footer_services')}</h3>
            <ul className="space-y-2">
              <li className="text-sm text-teal-50">{t('service_dental')}</li>
              <li className="text-sm text-teal-50">{t('service_plastic')}</li>
              <li className="text-sm text-teal-50">{t('service_antiaging')}</li>
              <li className="text-sm text-teal-50">{t('service_eye')}</li>
              <li className="text-sm text-teal-50">{t('service_checkup')}</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-base font-semibold mb-4">{t('footer_contact_us')}</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <i className="ri-mail-line text-lg mt-0.5 mr-3"></i>
                <div>
                  <p className="text-xs text-teal-50 mb-1">{t('footer_email_label')}</p>
                  <a href="mailto:medivoyage.uz@gmail.com" className="text-sm hover:text-white transition-colors">
                    medivoyage.uz@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-phone-line text-lg mt-0.5 mr-3"></i>
                <div>
                  <p className="text-xs text-teal-50 mb-1">{t('footer_phone_label')}</p>
                  <a href="tel:+998931121464" className="text-sm hover:text-white transition-colors">
                    +998 93 112 14 64
                  </a>
                </div>
              </div>
              <div>
                <p className="text-sm font-medium mb-2">{t('footer_follow_us')}</p>
                <div className="flex space-x-3">
                  <a href="https://www.instagram.com/medivoyage_uz/" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors">
                    <i className="ri-instagram-line text-base"></i>
                  </a>
                  <a href="https://www.facebook.com/profile.php?id=61575547326207" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors">
                    <i className="ri-facebook-line text-base"></i>
                  </a>
                  <a href="#" className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors">
                    <i className="ri-telegram-line text-base"></i>
                  </a>
                  <a href="#" className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors">
                    <i className="ri-whatsapp-line text-base"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-teal-500 mt-8 pt-8 text-center">
          <p className="text-sm text-teal-50">{t('footer_rights')}</p>
        </div>
      </div>
    </footer>
  );
}